"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatValue = function formatValue(val) {
  if (typeof val === 'number') {
    return Number.parseFloat(val).toFixed(2);
  }

  return val;
};

var DataCell = function DataCell(props) {
  var units = props.units,
      value = props.value;
  return /*#__PURE__*/_react["default"].createElement("div", null, formatValue(value), /*#__PURE__*/_react["default"].createElement("sub", null, units));
};

var _default = DataCell;
exports["default"] = _default;
DataCell.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  units: _propTypes["default"].string.isRequired
} : {};